import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import WorkflowStep from '../../WorkflowStep';
import BillingPage from './BillingPage';
import ReviewPage from './ReviewPage';
import OptionalBeneficiaryContainer from './OptionalBeneficiaryContainer';
import userActions from '../../../user/userActions';
import policyActions from '../../../policy/policyActions';
import paymentActions from '../../../payment/paymentActions';
import authActions from '../../../auth/authActions';

interface Props {
	// passed props
	actions: any;
	className?: string;
	customerPolicy: CustomerPolicy;
	user: UserDetails;
	history: any;
	match?: any;
	questionnaire?: any;
	onUserChange?: (e: any) => void;

	// redux props
	currentUser: UserDetails;
	customerDetails: CustomerDemographicDetails;
	premiumChanged: boolean;
	isSoftDeclined: DeclineCheckerDto;
	referrals: CustomerReferralResponse;
}
interface State {
	isLoading: boolean;
	isSoftDeclineChecking: boolean;
}
class BillingReviewPage extends React.Component<Props, State> {
	state = {
		isLoading: true,
		isSoftDeclineChecking: true
	};

	componentDidMount() {
		this.props.actions.fetchIsSoftDeclined(this.props.user.id, this.props.customerPolicy.id)
			.then(this.updatePolicy)
			.then(() => {
				if (this.props.isSoftDeclined.isDeclined) {
					return this.props.history.push(`/quote/declined`);
				}
				else {
					// only show page if not declined, this prevents flashing the review page before redirecting.
					this.setState({ isSoftDeclineChecking: false, isLoading: false });
				}
			})
			.catch(() => {
				return this.props.history.push(`/quote/declined`);
			});
	}

	updatePolicy = () => {
		// updates the pending policy with today's date and ensures the correct rate after all questions are answered.
		const originalPremium = this.props.customerPolicy.rate!;
		return this.props.actions.updatePolicy(this.props.customerPolicy.id)
			.then(() => {
				if (this.props.customerPolicy.rate! > originalPremium) {
					this.props.actions.setPremiumChanged(true);
				} 
				else {
					this.props.actions.setPremiumChanged(false);
				}
			});
	}

	render() {
		const { className, ...props } = this.props;
		const congratsText = props.match.params.enrollmentPage !== 'billing' ?
			(
				<div>
					<div>Your application has been approved!</div>
					<div>Details of your term life policy are as follows.</div>
				</div>
			)
			: 'Please enter your payment details and click Enroll to begin your coverage.';
		return !this.state.isSoftDeclineChecking && (
			<WorkflowStep className={className} title={congratsText}>
				{props.match.params.enrollmentPage === 'review' &&
					<ReviewPage
						{...props}
						hidden={false}
						isLoading={this.state.isLoading}
					/>
				}
				{props.match.params.enrollmentPage === 'beneficiary' &&
					<OptionalBeneficiaryContainer
						{...props}
						hidden={false}
					/>
				}
				{props.match.params.enrollmentPage === 'billing' &&
					<BillingPage
						{...props}
						hidden={false}
					/>
				}
			</WorkflowStep>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		currentUser: state.auth.currentUser,
		customerDetails: state.quoting.customerDetails,
		premiumChanged: state.policy.premiumChanged,
		isSoftDeclined: state.policy.isSoftDeclined,
		referrals: state.user.referrals
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...userActions, ...policyActions, ...paymentActions, ...authActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(BillingReviewPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/billing-review/BillingReviewPage.tsx